module.exports = __webpack_public_path__ + "img/card1.c7c57535.jpg";